export default __webpack_public_path__ + "scene1_3_icon9d61cb.png";